import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Recommendations from "@/pages/Recommendations";
import SurfArea from "@/pages/SurfArea";
import Dashboard from "@/pages/Dashboard";
import Businesses from "@/pages/Businesses";
import BusinessDetail from "@/pages/BusinessDetail";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Safety from "@/pages/Safety";
import SurfSpotsIndex from "@/pages/SurfSpotsIndex";
import CountryHub from "@/pages/CountryHub";
import RegionHub from "@/pages/RegionHub";

function AppRoutes() {
  const { loading } = useAuth();
  useEffect(() => {
    document.title = "Surfmatics — Find your best surf";
  }, []);
  if (loading) return null;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
        <Route path="/recommendations" element={<Recommendations />} />
        {/* SEO hubs */}
        <Route path="/surf-spots" element={<SurfSpotsIndex />} />
        <Route path="/surf-spots/:country" element={<CountryHub />} />
        <Route path="/surf-spots/:country/:region" element={<RegionHub />} />
        <Route path="/surf-spots/:country/:region/:slug" element={<SurfArea />} />
        <Route path="/beginner-surf/:country/:region" element={<RegionHub topic="beginner-surf" />} />
        {/* Legacy spot URL — kept so old links still work */}
        <Route path="/surf-area/:slug" element={<SurfArea />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/businesses" element={<Businesses />} />
        <Route path="/business/:id" element={<BusinessDetail />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="/about" element={<About />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
